import { render, staticRenderFns } from "./contacts-icon-box.vue?vue&type=template&id=d3889c56&scoped=true&"
import script from "./contacts-icon-box.vue?vue&type=script&lang=js&"
export * from "./contacts-icon-box.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3889c56",
  null
  
)

export default component.exports